export default "/build/frontend/fonts/vendor/lightgallery/lg.woff?356a0e9cb064c7a196c612ebf7523686";